<template>
	<div class="bg-white all margin-left padding-lr">
		<el-form label-width="100px" :model="formLabelAlign" :inline="true" ref="ruleForm">
		  <el-form-item label="封面">
		    <div class="width700">
				<el-upload
				  class="avatar-uploader upload"
				  action="https://manage.ciiply.com/api/pc/user/upFile"
				  :show-file-list="false"
				  :on-success="handleAvatarSuccess"
				  :before-upload="beforeAvatarUpload">
				  <img v-if="formLabelAlign.imageUrl" :src="formLabelAlign.imageUrl" class="avatar">
				  <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
				  <div v-else class="upload flex flex-direction align-center justify-center bg-white dvly">
				  	<img class="uploadimg" src="../../../assets/img/upload.png">
				  	<div class="text-sm text-999">点击上传封面</div>
				  </div>
				</el-upload>
			</div>	
		  </el-form-item>
		  <el-form-item label="发布形式">
		    <el-select :disabled="isdisable" v-model="formLabelAlign.typename" placeholder="请选择发布形式">
		    	<el-option v-for="(item,index) in type" :key="index" :label="item.name" :value="item.id"></el-option>
		    </el-select>
		  </el-form-item>
		  <el-form-item label="课程类别">
		    <el-cascader :disabled="isdisable" v-model="formLabelAlign.value" :options="options" :props="props"
		    	@change="handleChange"></el-cascader>
		  </el-form-item>
		  <el-form-item label="设置价格">
		      <div class="width700 flex align-start">
				  <el-input :disabled="isdisable" class="price-input" v-model="formLabelAlign.price" placeholder="0~300以内,若“0”元将无收入"></el-input>
				  <p class="margin-left-xs">元</p>
			  </div>
		    </el-form-item>
			<el-form-item label="标题">
			    <div class="width700 flex align-start">
				  <el-input :disabled="isdisable" v-model="formLabelAlign.title" placeholder="请输入标题（建议20字以内）"></el-input>
				</div>
			</el-form-item>
			<el-form-item label="介绍">
			    <el-input :disabled="isdisable" class="width700 height226" type="textarea" v-model="formLabelAlign.desc" placeholder="请输入具体课程介绍"></el-input>
			</el-form-item>
			<el-form-item label="课程章节" v-if="isedit != 0">
			   <div class="flex align-center justify-between width700">
				   <div>当前目录内已上传{{chapter.length}}节课</div>
				   <div class="add_btn pointer" @click="addcha">添加章节</div>
			   </div>
			   <div class="margin-top-sm">
					<div class="flex align-center justify-between list-sm margin-bottom-sm" v-for="(item,index) in chapter" :key="index">
						<div class="flex align-center">
						   <img v-if="formLabelAlign.typename == 0" class="block-33 margin-right-xs" src="../../../assets/img/broadcast.png" >
						   <img v-if="formLabelAlign.typename == 1" class="block-33 margin-right-xs" src="../../../assets/img/pdf.png" >
						   <p>{{item.chapter_title}}</p>
						</div>
						<div class="flex align-center">
							<img @click="edit(item)" class="edite pointer margin-right-sm" src="../../../assets/img/edite.png" >
							<img @click="deleteChatper(item)" class="del pointer" src="../../../assets/img/del.png" >
						</div>
					</div>
			   </div>
			</el-form-item>
			<div>
				<el-radio v-model="radio" label="1">发布课程即表示遵守 <span class="text-theme">《蓝友网信息发布规则》</span>，如果您违反规则可能导致您的账号异常 </el-radio>
			</div>
			<el-button class="creat" type="primary" @click="submitForm('ruleForm')">{{isedit == 0?'去添加章节':'保存修改'}}</el-button>
			<p class="text-xs text-999">发布成功后，平台会在1个工作日内审核完成即可显示</p>
		</el-form>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			var checktyimageUrl = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('封面图不能为空'));
				}
				callback();
			};
			var checktyvalue = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('课程分类不能为空'));
				}
				callback();
			};
			var checktypename = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('发布形式不能为空'));
				}
				callback();
			};
			var checktitle = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('标题不能为空'));
				}
				callback();
			};
			var checkdesc = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('介绍不能为空'));
				}
				callback();
			};
			
			return {
				formLabelAlign:{
					imageUrl:'',//
					typename:'',//发布形式
					value:'',//课程类别
					price:'',//设置价格
					title:'',//标题
					desc:'',//介绍
				},
				rules: {
					imageUrl:[{
						validator: checktyimageUrl,
						trigger: 'blur'
					}],
					typename: [{
						validator: checktypename,
						trigger: 'blur'
					}],
					value:[{
						validator: checktyvalue,
						trigger: 'blur'
					}],
					title: [{
						validator: checktitle,
						trigger: 'blur'
					}],
					desc:[{
						validator: checkdesc,
						trigger: 'blur'
					}],
				},//表单验证规则 
				imageUrl:null,//封面图
				radio:"1",
				props: {
					label:'category_name',
					children:'two',
					value:'id',
					expandTrigger: 'hover',
				},
				type: [
					{
						name: '文件课程',
						id:1
					},
					{
						name: '视频课程',
						id:0
					}
				],//课程类型
				options: [],//课程类别
				course_id:0,
				chapter:[],//章节列表
				isdisable:false,
				isedit:0,//0  发布  1 编辑
			};
		},
		created(){
			this.getcourseCategroy()
			
			Bus.$on('getdexatail',data=>{
				console.log('getdexatail',data);
				this.course_id = data.id
				this.isedit = data.isedit
				this.getdetail()
				this.getChatper()
			})
			Bus.$on('addChatper',data=>{
				this.getChatper()
			})
		},
		destroyed() {
			Bus.$off()
		},
		methods: {
			/**
			 * 详情
			 * */
			getdetail(){
				this.ajax('get', '/api/pc/courseapply/getApplyInfo',{
					id:this.course_id,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.formLabelAlign.title = res.data.course.title
						this.formLabelAlign.typename = res.data.course.type
						this.formLabelAlign.price = res.data.course.price
						// this.chapter = res.data.chapter
						this.formLabelAlign.desc = res.data.course.content
						// this.formLabelAlign.value = res.data.course.category_id
						let id = res.data.course.category_id
						let arr = []
						this.options.map((item,lced)=>{
							item.two.map((ele,xond)=>{
								if(ele.id == id){
									arr.push(item.id)
									arr.push(ele.id)
								}
							})
						})
						console.log(arr);
						this.formLabelAlign.value = arr
						this.formLabelAlign.imageUrl = res.data.course.logo
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 获取用工分类
			 * */
			getcourseCategroy(){
				this.ajax('get', '/api/pc/courseCateGory/getList', {
					type:2
				}, res => {
					if(res.status == 200){
						this.options= res.data
					}
				})
			},
			/**
			 * 上传图片
			 * */
			handleAvatarSuccess(res, file) {
				console.log(res, file)
				this.formLabelAlign.imageUrl = res.data.url;
			},
			/**
			 * 上传图片
			 * */
			beforeAvatarUpload(file) {
				// const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
				  this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return  isLt2M;
			},
			
			/**
			 * 选择分类
			 * */
			handleChange(value) {
				console.log(value);
			},
			//添加章节
			addcha(){
				if(this.isedit == 0){
					this.unloading()
				}else{
					this.editexamine()
				}
				
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(this.isedit);
						// this.addexamine()
						if(this.isedit == 0){
							this.unloading()
						}else{
							this.editexamine()
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			/**
			 * 发布课程
			 * 发布课程流程：先发布在上传章节最后保存
			 * */ 
			unloading(){
				let that = this
				let data={
					title:this.formLabelAlign.title,
					category_id:this.formLabelAlign.value[1],
					logo:this.formLabelAlign.imageUrl,
					content:this.formLabelAlign.desc,
					price:this.formLabelAlign.price||0,
					type:this.formLabelAlign.typename,
					
				}
				that.ajax('post', '/api/pc/courseapply/release',data, res => {
					console.log(res);
					if(res.status == 200){
						let type = {
							type:'exadetail',
							typeone:'examine'
						}
						that.$emit('gettype',type)
						// console.log(e);
						setTimeout(() => {
						     Bus.$emit('getdid',res.data[0])
						   }, 20);
						   
						// let info = {
						// 	id:res.data[0],
						// 	type:this.formLabelAlign.typename
						// }
						// this.course_id = res.data[0]
						// this.isdisable = true
						
						// this.$emit('addcha')
						// setTimeout(()=>{
						// 	Bus.$emit('release',info)
						// },500)
						
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 获取章节
			 * */
			getChatper(){
				this.ajax('get', '/api/pc/courseapply/getChatper',{
					id:this.course_id
				}, res => {
					console.log(res);
					if(res.status == 200){
						if(res.data.length > 0){
							res.data.map(item=>{
								item.isedp = false
							})
						}
						this.chapter = res.data
					}else{
						this.$message(res.msg);
					}
				})
			},
			
			/**
			 * 修改课程
			 * 先修改课程描述 在添加章节或者直接发布
			 * */
			editexamine(){
				let data={
					title:this.formLabelAlign.title,
					category_id:this.formLabelAlign.value[1],
					logo:this.formLabelAlign.imageUrl,
					content:this.formLabelAlign.desc,
					price:this.formLabelAlign.price||0,
					type:this.formLabelAlign.typename,
					id:this.course_id
				}
				let info = {
					id:this.course_id,
					type:this.formLabelAlign.typename
				}
				this.ajax('post', '/api/pc/courseapply/courseApplyEdit',data, res => {
					console.log(res);
					if(res.status == 200){
						
						this.isdisable = true
						this.$emit('addcha')
						this.$message('修改提交成功');
						setTimeout(()=>{
							
							Bus.$emit('release',info)
						},500)
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 发布
			 * */
			addexamine(){
				this.ajax('post', '/api/pc/courseapply/examine',{
					id:this.course_id
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.$message('提交成功');
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 删除章节
			 * */
			deleteChatper(item){
				this.ajax('post', '/api/pc/courseapply/deleteChatper',{
					id:item.id
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.$message('删除成功');
						this.getChatper()
					}else{
						this.$message(res.msg);
					}
				})
			},
			edit(item){
				let info = {
					id:this.course_id,
					type:this.formLabelAlign.typename
				}
				this.$emit('addcha')
				setTimeout(()=>{
					Bus.$emit('release',info)
					Bus.$emit('editrelease',item)
				},500)
			}
		}
	}
</script>

<style scoped lang="less">
	.all {
		width: 921px;
		
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204, 204, 204, 0.2000);
		border-radius: 20px;
		padding-top: 40px;
		padding-bottom: 40px;
	}
	.width700{
		width: 740px;
	}
	.height226{
		height: 226px;
	}
	
	/deep/ .el-textarea__inner{
		height: 226px;
	}
	.label{
		width: 100px;
		height: 40px;
		line-height: 40px;
	}
	.add_btn{
		width: 106px;
		height: 40px;
		background: rgba(230,230,230,0.3000);
		border: 1px solid #09827B;
		border-radius: 8px;
		color: #09827B;
	}
	.edite{
		width:30px;
		height:28px;
	}
	.del{
		width:23px;
		height:23px;
	}
	.title {
		width: 110px;
	}
	.el-select,.el-cascader,.price-input{
		width: 310px;
	}
	.block-33{
		width: 33px;
		height: 33px;
	}
	/deep/ .el-form-item__label{
		text-align: center !important;
	}
	.upload {
		width: 128px;
		height: 164px;
		position: relative;
		background: rgba(230, 230, 230, 0.1000);
		border: 1px solid #E6E6E6;

		.uploadimg {
			width: 46px;
			height: 36px;
		}
	}
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
		width: 128px;
		height: 164px;
	  }
	 
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	  .avatar {
	    width: 128px;
	    height: 164px;
	    display: block;
	  }
	.list-sm{
		width: 739px;
		height: 54px;
		background: rgba(230,230,230,0.1000);
		border: 1px solid #E6E6E6;
		border-radius: 8px;
		padding: 10px 20px;
	}
	.creat {
		width: 383px;
		height: 46px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9, 130, 123, 0.2000);
		border-radius: 23px;
		margin-top: 60px;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/curriculum/release.vue